"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactRouterDom = require("react-router-dom");
var _SpinErrorTable = _interopRequireDefault(require("./SpinErrorTable.js"));
var _reactResponsive = _interopRequireDefault(require("react-responsive"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SpinTable = /*#__PURE__*/function (_React$Component) {
  _inherits(SpinTable, _React$Component);
  var _super = _createSuper(SpinTable);
  function SpinTable(props) {
    var _this;
    _classCallCheck(this, SpinTable);
    _this = _super.call(this, props);
    _this.getCorlorCodForGrade = function (grade) {
      if (grade === 'A') return '#7ED321';
      if (grade === 'B') return '#7ED321';
      if (grade === 'C') return '#FFC814';
      if (grade === 'D') return '#FE8F40';
      if (grade === 'E') return '#FF4E3E';
    };
    _this.state = {
      expanded: false,
      open: false,
      currentStats: ''
    };
    return _this;
  }
  _createClass(SpinTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var showModal = this.state.open ? 'displayBlock' : 'displayNone';
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
        className: "missonmodal spinModal " + showModal,
        style: {
          paddingLeft: '18px',
          paddingRight: '18px',
          background: "white"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'modalContent  respPadding spin-error-modal ' + this.props.isLiveView ? "my-error" : "",
        style: {
          width: "100%",
          height: "auto",
          marginTop: "15px"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "bottom",
        style: {
          paddingBottom: "16.42px"
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "my-errors-heading"
      }, this.props.i18next.t("lable.myErrors")), /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
        minWidth: 992
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "mg-btn greyBtnLiveReport btnHalo livestateTable_collapse_btn spin-Closebtn closeButtonhoverEffect",
        style: {
          width: "80.4px",
          height: '33px',
          "float": 'right'
        },
        onClick: function onClick() {
          _this2.setState({
            open: false
          });
        }
      }, this.props.i18next.t("lable.CLOSE"))), /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
        maxWidth: 991
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-times faCloseBtn",
        "aria-hidden": "true",
        onClick: function onClick() {
          _this2.setState({
            open: false
          });
        }
      }))), this.state.currentStats != '' && this.props.biggestErrorBySituations.filter(function (obj) {
        return obj.situation === _this2.state.currentStats;
      }).length > 0 && /*#__PURE__*/_react["default"].createElement(_SpinErrorTable["default"], {
        i18next: this.props.i18next,
        category: 'Tight Error',
        ismodal: true,
        errorHands: this.props.biggestErrorBySituations.filter(function (obj) {
          return obj.situation === _this2.state.currentStats;
        })[0],
        handReplayerOpen: function handReplayerOpen(item) {
          return _this2.props.handReplayerOpen(item);
        }
      }))), /*#__PURE__*/_react["default"].createElement("table", {
        className: "spinRepo_table",
        style: {
          width: "100%",
          fontSize: "14px",
          color: '#020202',
          marginTop: '17.45',
          backgroundColor: "white"
        }
      }, /*#__PURE__*/_react["default"].createElement("thead", {
        className: "resp-table-head"
      }, /*#__PURE__*/_react["default"].createElement("tr", {
        className: "resp-table-tr",
        style: {
          backgroundColor: "#fff !important"
        }
      }, /*#__PURE__*/_react["default"].createElement("th", {
        width: "10%",
        className: "resp_playerStat_th spinRepo_th"
      }, this.props.i18next.t("lable.Stat")), /*#__PURE__*/_react["default"].createElement("th", {
        width: "5%",
        className: "resp_playerStat_th hide-prop spinRepo_th"
      }), /*#__PURE__*/_react["default"].createElement("th", {
        width: "7%",
        className: "resp_playerStat_th spinRepo_th"
      }, this.props.i18next.t("lable.Grade")), /*#__PURE__*/_react["default"].createElement("th", {
        width: "10%",
        className: "resp_playerStat_th spinRepo_th"
      }, this.props.i18next.t("lable.gradeRange")), /*#__PURE__*/_react["default"].createElement("th", {
        width: "9%",
        className: "resp_playerStat_th spinRepo_th"
      }, this.props.i18next.t("lable.handsRequired")), /*#__PURE__*/_react["default"].createElement("th", {
        width: "1%",
        className: "resp_playerStat_th spinRepo_th"
      }, "\xA0"), /*#__PURE__*/_react["default"].createElement("th", {
        width: "32%",
        className: "resp_playerStat_th spinRepo_th"
      }, this.props.i18next.t("lable.comment")), /*#__PURE__*/_react["default"].createElement("th", {
        width: "8%",
        className: "resp_playerStat_th spinRepo_th"
      }))), /*#__PURE__*/_react["default"].createElement("tbody", {
        "data-e2e": "catInsideTable",
        className: "resp-table-body"
      }, this.props.playerStatistics.map(function (key, index) {
        return _this2.props.category == key.category && /*#__PURE__*/_react["default"].createElement("tr", {
          key: index,
          className: "resp_playerStat_tr spin-tr-bottom"
        }, /*#__PURE__*/_react["default"].createElement("td", {
          className: "resp_playerStat_td spinRepo_td"
        }, /*#__PURE__*/_react["default"].createElement("span", null, key.stat), /*#__PURE__*/_react["default"].createElement("i", {
          style: {
            color: '#DE460F'
          },
          className: "fa fa-question-circle mobileHeader",
          "data-tip": key.toolTip,
          "aria-hidden": "true"
        })), /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            padding: '0'
          },
          className: "resp_playerStat_td hide-prop spinRepo_td"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          style: {
            color: '#DE460F'
          },
          className: "fa fa-question-circle",
          "data-tip": key.toolTip,
          "aria-hidden": "true"
        })), /*#__PURE__*/_react["default"].createElement("td", {
          "data-title": "Grade:",
          className: "resp_playerStat_td spinRepo_td"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "cursive",
          style: {
            color: _this2.getCorlorCodForGrade(key.grade),
            fontSize: '2em',
            fontWeight: 'bold'
          }
        }, key.grade)), /*#__PURE__*/_react["default"].createElement("td", {
          "data-title": "Preferred Range:",
          className: "resp_playerStat_td spinRepo_td"
        }, key.prefRange), /*#__PURE__*/_react["default"].createElement("td", {
          "data-title": "Minimum Hands Required:",
          className: "resp_playerStat_td spinRepo_td"
        }, key.minimum_hand_requirement, key.minimum_hand_requirement < _this2.props.handsAnalysed || key.minimum_hand_requirement == _this2.props.handsAnalysed ? null : /*#__PURE__*/_react["default"].createElement("i", {
          style: {
            color: '#DE460F'
          },
          className: "fa fa-exclamation-triangle",
          "data-tip": "Insufficient hands played for this statistic to be reliable",
          "aria-hidden": "true"
        })), /*#__PURE__*/_react["default"].createElement("td", {
          "data-e2e": "reportCardValues",
          "data-title": "",
          className: "resp_playerStat_td spinRepo_td"
        }, ""), /*#__PURE__*/_react["default"].createElement("td", {
          "data-title": "Comment:",
          style: {
            fontSize: 12
          },
          className: "resp_playerStat_td spinRepo_td"
        }, key.comment), /*#__PURE__*/_react["default"].createElement("td", {
          className: "resp_playerStat_td resp_playerStat_td_livereport spinRepo_td"
        }, ['Postflop', 'Winrates'].indexOf(_this2.props.category) === -1 && _this2.props.isLiveView ? _this2.props.biggestErrorBySituations.filter(function (obj) {
          return obj.situation === key.stat;
        })[0].hands.length > 0 : _this2.props.biggestErrorBySituations.filter(function (obj) {
          return obj.situation === key.stat;
        }).length > 0 ? /*#__PURE__*/_react["default"].createElement("button", {
          className: "mg-btn myErrorBtn",
          onClick: function onClick() {
            _this2.setState({
              open: true,
              currentStats: key.stat.endsWith("6-12") ? key.stat.replace("6-12", '12-') : key.stat
            });
          },
          style: {
            cursor: 'pointer',
            minWidth: "200px",
            backgroundColor: 'white'
          }
        }, _this2.props.i18next.t("lable.MYERRORS")) : ['Postflop', 'Winrates'].indexOf(_this2.props.category) === -1 && /*#__PURE__*/_react["default"].createElement("button", {
          className: "mg-btn NoErrorBtn",
          style: {
            cursor: 'none',
            minWidth: "200px",
            backgroundColor: 'white'
          }
        }, _this2.props.i18next.t("lable.NOERRORS"))));
      }))));
    }
  }]);
  return SpinTable;
}(_react["default"].Component);
var _default = (0, _reactRouterDom.withRouter)(SpinTable);
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/SpinTable.js
 ** module id = 2402
 ** module chunks = 0
 **/